import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=22837b9c&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=js&"
export * from "./AddDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=22837b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22837b9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22837b9c')) {
      api.createRecord('22837b9c', component.options)
    } else {
      api.reload('22837b9c', component.options)
    }
    module.hot.accept("./AddDialog.vue?vue&type=template&id=22837b9c&scoped=true&", function () {
      api.rerender('22837b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rebate/components/AddDialog.vue"
export default component.exports